<template>
    <div class="float-left mr-1">
        <b-button variant="warning" @click.stop="confirmarReprovacao()">
            <span> <i class="fa fa-ban mr-2"></i> Reprovar </span>
        </b-button>
    </div>
</template>

<script>
import SolicitacoesAcessoServicos from './SolicitacoesAcessoServicos'

export default {
    props: {
        solicitacaoAcessoId: {
            type: String,
            default: ''
        },

        cpfCnpjFornecedor: {
            type: String,
            default: ''
        },

        razaoSocialFornecedor: {
            type: String,
            default: ''
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarReprovacao() {
            this.$swal({
                title: 'Solicitação de Acesso',
                html: `Confirma a REPROVAÇÃO da solicitação de acesso do fornecedor
                    ${this.cpfCnpjFornecedor} - ${this.razaoSocialFornecedor}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa da reprovação',
                inputValidator: value => {
                    if (!value) {
                        return 'A justificativa da reprovação é obrigatória'
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovarSolicitacaoAcesso(result.value)
                }
            })
        },

        reprovarSolicitacaoAcesso(justificativa) {
            this.$store.dispatch('addRequest')
            let solicitacaoAcessoDto = {
                solicitacaoAcessoId: this.solicitacaoAcessoId,
                justificativa: justificativa
            }
            SolicitacoesAcessoServicos.reprovar(solicitacaoAcessoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.$emit('atualizarErro', response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Solicitação de acesso reprovada com sucesso',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterSolicitacaoAtualizada')
        }
    }
}
</script>
